import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useInView } from '../hooks/useInView';
import { propertiesApi } from '../services/api';
import PropertyCard from './PropertyCard';

const ForSaleSection = () => {
  const [ref, isInView] = useInView({ threshold: 0.1 });
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadProperties();
  }, []);

  const loadProperties = async () => {
    try {
      const data = await propertiesApi.getAll('en_vente');
      setProperties(data);
    } catch (error) {
      console.error('Error loading properties:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section ref={ref} className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className={`text-center mb-12 transition-all duration-400 ${
            isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-[#8B2942] mb-4">En vente</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Découvrez nos biens actuellement disponibles à la vente
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#8B2942]"></div>
          </div>
        ) : properties.length > 0 ? (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {properties.slice(0, 2).map((property, index) => (
                <PropertyCard key={property.id} property={property} index={index} />
              ))}
            </div>

            {properties.length > 2 && (
              <div className="text-center mt-10">
                <Button asChild variant="outline" size="lg" className="group border-[#8B2942] text-[#8B2942] hover:bg-[#8B2942] hover:text-white">
                  <Link to="/a-vendre" className="flex items-center gap-2">
                    Voir tous les biens à vendre ({properties.length})
                    <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
                  </Link>
                </Button>
              </div>
            )}
          </>
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-600">Aucun bien disponible pour le moment</p>
            <Button asChild className="mt-4 bg-[#8B2942] hover:bg-[#6d2033]">
              <Link to="/contact">Contactez-nous</Link>
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};

export default ForSaleSection;
